import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { useTranslation } from '../useTranslation';

const Academie = () => {
  const { t } = useTranslation();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const category = "academie";

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const { data, error } = await supabase
          .from("category_images")
          .select("id, url, category")
          .eq("category", category);

        if (error) throw error;

        setImages(data);
      } catch (err) {
        console.error("Erreur de chargement des images :", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  return (
    <>
     <style>{`
    body {
    background: #0c0b09;
    }
  `}</style>

      {/* Section Événements */}
      <section id="events" className="events">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>{t('academyTitle')}</h2>
<p>{t('academySubtitle')}</p>
          </div>

          <div className="events-slider swiper-container" data-aos="fade-up" data-aos-delay="100">
            <div className="swiper-wrapper">
              {['birthday', 'private', 'custom'].map((eventType) => (
                <div className="swiper-slide" key={eventType}>
                  <div className="row event-item">
                    <div className="col-lg-6">
                       <img 
                        src={`assets/img/training.jpg`} 
                        className="img-fluid event-image"
                        alt={`${eventType} event`}
                        style={{
                          width: '100%',
                          height: '400px',
                          objectFit: 'cover',
                          objectPosition: 'center'
                        }}
                      />
                    </div>
                    <div className="col-lg-6 pt-4 pt-lg-0 content">
  <h3>{t('ourAcademy')}</h3>
  <div className="price">
    <p><span></span></p>
  </div>
  <p className="fst-italic">
    {t('academyDescription')}
  </p>
  <ul>
    <li><i className="bi bi-check-circle"></i> {t('academyFeature1')}</li>
    <li><i className="bi bi-check-circle"></i> {t('academyFeature2')}</li>
    <li><i className="bi bi-check-circle"></i> {t('academyFeature3')}</li>
  </ul>
  <p>
    {t('academyConclusion')}
  </p>
</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </section>

      {/* Section Spéciaux */}
      <section id="specials" className="specials">
  <div className="container" data-aos="fade-up">
    <div className="section-title">
      <h2>{t('academySpecialsTitle')}</h2>
      <p>{t('academySpecialsSubtitle')}</p>
    </div>

    <div className="row" data-aos="fade-up" data-aos-delay="100">
      <div className="col-lg-3">
        <ul className="nav nav-tabs flex-column">
          {[1, 2, 3].map((tab) => (
            <li className="nav-item" key={tab}>
              <a 
                className={`nav-link ${tab === 1 ? 'active show' : ''}`}
                data-bs-toggle="tab" 
                href={`#tab-${tab}`}
              >
                {tab === 1 && t('oilTab')}
                {tab === 2 && t('honeyTab')}
                {tab === 3 && t('soapTab')}
              </a>
            </li>
          ))}
        </ul>
      </div>
      
      <div className="col-lg-9 mt-4 mt-lg-0">
        <div className="tab-content">
          {[1, 2, 3].map((tab) => (
            <div 
              className={`tab-pane ${tab === 1 ? 'active show' : ''}`} 
              id={`tab-${tab}`} 
              key={tab}
            >
              <div className="row">
                <div className="col-lg-8 details order-2 order-lg-1">
                  <h3>
                    {tab === 1 && t('oilTitle')}
                    {tab === 2 && t('honeyTitle')}
                    {tab === 3 && t('soapTitle')}
                  </h3>
                  <p style={{ whiteSpace: 'pre-line' }}>
                    {tab === 1 && t('oilDescription')}
                    {tab === 2 && t('honeyDescription')}
                    {tab === 3 && t('soapDescription')}
                  </p>
                </div>
                <div className="col-lg-4 text-center order-1 order-lg-2">
                  <img 
                    src={`assets/img/specials-${tab}.jpg`} 
                    alt="" 
                    className="img-fluid"
                    style={{
                      width: '100%',
                      height: '180px',
                      objectFit: 'cover'
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Section Chefs */}
      <section id="chefs" className="chefs">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
           <h2>{t('trainersTitle')}</h2>
<p>{t('trainersSubtitle')}</p>
          </div>

          <div className="row">
            {[
              { id: 1, name: "Max White", role: "Oil trainer", delay: 100 },
              { id: 2, name: "Julia Jhonson", role: "Honey trainer", delay: 200 },
              { id: 3, name: "William Anderson", role: "Soap trainer", delay: 300 }
            ].map((chef) => (
              <div className="col-lg-4 col-md-6" key={chef.id}>
                <div className="member" data-aos="zoom-in" data-aos-delay={chef.delay}>
                  <img 
                    src={`assets/img/chefs/trainer-${chef.id}.jpg`} 
                    className="img-fluid chef-image"
                    alt={chef.name}
                    style={{
                      width: '100%',
                      height: '400px',
                      objectFit: 'cover',
                      objectPosition: 'center'
                    }}
                  />
                  <div className="member-info">
                    <div className="member-info-content">
                      <h4>{chef.name}</h4>
                      <span>{chef.role}</span>
                    </div>
                    <div className="social">
                      <a href=""><i className="bi bi-twitter"></i></a>
                      <a href=""><i className="bi bi-facebook"></i></a>
                      <a href=""><i className="bi bi-instagram"></i></a>
                      <a href=""><i className="bi bi-linkedin"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Galerie */}
      <section id="gallery" className="gallery">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>{t('academyGalleryTitle')}</h2>
<p>{t('academyGallerySubtitle')}</p>
          </div>
        </div>

        <div className="container-fluid" data-aos="fade-up" data-aos-delay="100">
          {loading ? (
<p className="text-center">{t('loadingImages')}</p>
          ) : images.length === 0 ? (
<p className="text-center">{t('noAcademyImages')}</p>
          ) : (
            <div className="row g-0">
              {images.map((image) => (
                <div className="col-lg-3 col-md-4" key={image.id}>
                  <div className="gallery-item">
                    <a
                      href={image.url}
                      className="gallery-lightbox"
                      data-gall="gallery-item"
                    >
                      <img
                        src={image.url}
                        alt={`Image de la catégorie ${category}`}
                        className="img-fluid gallery-image"
                        style={{
                          width: '100%',
                          height: '250px',
                          objectFit: 'cover',
                          objectPosition: 'center'
                        }}
                      />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>      
    </>
  );
};

export default Academie;